import * as React from "react";
import { forwardRef } from "react";
const SvgThresholdNormal = (props, ref) => <svg width="1em" height="1em" viewBox="0 0 25 25" ref={ref} {...props}><g fill="none" stroke="#DADADA"><circle cx={12.5} cy={12.5} r={11.5} /><path d="m6.5 12.551 4.099 4.365L18.5 9" /></g></svg>;
const ForwardRef = forwardRef(SvgThresholdNormal);
export default ForwardRef;